import * as ActionTypes from "../ActionTypes";

const initialState = {
  isLoading: false,
  isLoaded: false,
  error: null,
};

export const FaceApiReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.FACEAPI_LOAD_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };

    case ActionTypes.FACEAPI_LOAD_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        error: null,
      };

    case ActionTypes.FACEAPI_LOAD_FAILURE:
      return {
        ...state,
        isLoading: false,
        isLoaded: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default FaceApiReducer;
